import EmptyLocationCard from './EmptyLocationCard';

export default EmptyLocationCard;
